import React from 'react';
import Select from 'react-select';
import './Dropdown.css';
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { isDisabled } from '@testing-library/user-event/dist/utils';

const Dropdown = ({ label, required, value, onChange, options, placeholder, error, inputClassName ,isDisabled,tippyContent}) => {
  const handleChange = (selectedOption) => {
    onChange({ target: { value: selectedOption ? selectedOption.value : '' } });
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: 'none',
      boxShadow: state.isFocused ? 'none' : 'none', // Remove box shadow only when focused
      
    }),
  };
  return (
   
    <div className="form-group-Dropdown">
      <label>
      {label} {required && <span style={{color:'red'}}>*</span>}
      </label>
   {console.log('label',label,options?.find(option => option.value === value),'options?.find(option => option.value === value)',options,'>>>>>>>>>>>>>>>>',value)}
      <Select
        value={options?.find(option => option.value === value)}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        className={`dropdown ${error ? 'error' : ''} ${inputClassName}`}
        styles={customStyles}
        isDisabled={isDisabled}

      />
    
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Dropdown;

